import styled from '@emotion/styled'
import { WebLink } from 'common/navigation/web-link'

export const StyledLogoWrapLink = styled(WebLink)({
    display: 'block',
    boxSizing: 'content-box',
    maxWidth: 642,
    width: '100%',
})
